import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Button/Button.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Button} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default button`}</h3>
    <p>{`This is the default variant for the `}<inlineCode parentName="p">{`Button`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button>Default</Button>
`}</code></pre>
    <h3>{`Danger button`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`danger`}</inlineCode>{` variant of `}<inlineCode parentName="p">{`Button`}</inlineCode>{` is used to warn users about potentially destructive actions`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button variant="danger">Danger</Button>
`}</code></pre>
    <h3>{`Outline button`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`outline`}</inlineCode>{` variant of `}<inlineCode parentName="p">{`Button`}</inlineCode>{` is typically used as a secondary button`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button variant="outline">Outline</Button>
`}</code></pre>
    <h3>{`Invisible button`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`invisible`}</inlineCode>{` variant of `}<inlineCode parentName="p">{`Button`}</inlineCode>{` indicates that the action is a low priority one.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button variant="invisible">Invisible</Button>
`}</code></pre>
    <h3>{`Different sized buttons`}</h3>
    <p><inlineCode parentName="p">{`Button`}</inlineCode>{` component supports three different sizes. `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Button size="small">Search</Button>
  <Button sx={{mt: 2}}>Search</Button>
  <Button sx={{mt: 2}} size="large">
    Search
  </Button>
</>
`}</code></pre>
    <h3>{`Appending an icon`}</h3>
    <p>{`We can place an icon inside the `}<inlineCode parentName="p">{`Button`}</inlineCode>{` in either the leading or the trailing position to enhance the visual context.
It is recommended to use an octicon here.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Button leadingIcon={SearchIcon}>Search</Button>
  <Button trailingIcon={SearchIcon} sx={{mt: 2}}>
    Search
  </Button>
  <Button leadingIcon={SearchIcon} trailingIcon={CheckIcon} sx={{mt: 2}}>
    Search
  </Button>
</>
`}</code></pre>
    <h3>{`Icon only button`}</h3>
    <p>{`A separate component called `}<inlineCode parentName="p">{`IconButton`}</inlineCode>{` is used if the action shows only an icon with no text. This button will remain square in shape.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<IconButton aria-label="Search" icon={SearchIcon} />
`}</code></pre>
    <h3>{`Different sized icon buttons`}</h3>
    <p><inlineCode parentName="p">{`IconButton`}</inlineCode>{` also supports the three different sizes. `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <IconButton aria-label="Search" size="small" icon={SearchIcon} />
  <IconButton aria-label="Search" icon={SearchIcon} sx={{ml: 2}} />
  <IconButton aria-label="Search" size="large" icon={SearchIcon} sx={{ml: 2}} />
</>
`}</code></pre>
    <h3>{`Counter component`}</h3>
    <p>{`A common use case for primer is a button with a counter component which shows the child count value.
We provide `}<inlineCode parentName="p">{`Button.Counter`}</inlineCode>{` as a composite component which requires you to provide a number as child.
The counter will match the `}<inlineCode parentName="p">{`variant`}</inlineCode>{` styles of the parent button.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button>
  Watch
  <Button.Counter>1</Button.Counter>
</Button>
`}</code></pre>
    <h3>{`Block button`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`block`}</inlineCode>{` prop for full width buttons.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Button block>Block</Button>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ButtonGroup"
        }}>{`ButtonGroup`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      